import type { SingleEntityState } from '@core/ngrx-legacy';
import { AnalyticsDevFlag, AnalyticsDevFlagsMap } from '@core/reports-types';

export const buildFlagsMap = (flags: AnalyticsDevFlag[]): AnalyticsDevFlagsMap =>
  Object.values(AnalyticsDevFlag).reduce(
    (map, key) => {
      map[key] = flags.includes(key);
      return map;
    },
    <AnalyticsDevFlagsMap>{},
  );

export const buildEmptyMap = (): AnalyticsDevFlagsMap =>
  Object.values(AnalyticsDevFlag).reduce(
    (map, key) => {
      map[key] = false;
      return map;
    },
    <AnalyticsDevFlagsMap>{},
  );

export const INITIAL_STATE: SingleEntityState<AnalyticsDevFlagsMap> = {
  data: buildEmptyMap(),
  loaded: false,
  pending: false,
  failed: false,
  error: undefined,
};
